import React from "react";
import AccountSummary from "../../../components/AccountSummary/AccountSummary";

const AccountSummaryPage = () => {
   return <AccountSummary />;
};

export default AccountSummaryPage;
